export default __webpack_public_path__ + "static/media/s.75e6bfd0.wav";